import React from "react";
import { Switch } from "react-router-dom";

// import AuthContext, { useAuth } from '../contexts/auth';

// import SignRoutes from './SignRoutes';
import InternalRoutes from "./InternalRoutes";

// O BrowserRouter sobe para App.js para que VoucherIdentificationGate
// e outros componentes top-level consigam usar hooks de router (useLocation).
const Routes = (campaign) => {
	return (
		<Switch>
			<InternalRoutes campaign={campaign} />
		</Switch>
	);
};

export default Routes;
